export const colourMaps = { wardColourMap, hospColourMap, specialtyColourMap };

function wardColourMap(ward) {
  const colours = {
    "C-DC Resp Xray": "#8f0000",
    MANCH: "#830100",
    HGDSB: "#9e0400",
    "J-WD Neuro ICU": "#d70800",
    "C-WD Recovery": "#df0c00",
    "J-DC 5F DCU": "#760800",
    "WL5 D": "#840a00",
    "C-WD 15 Urology": "#b81100",
    "J-WD JR_Chi CDU": "#6a0b00",
    "WL7 E": "#9b1300",
    "J-WD 5AU": "#e41f00",
    "J-DC Cath Lab D": "#831300",
    SEUWD: "#b61e00",
    "J-WD 5D Resp": "#781500",
    BHDRW: "#881a00",
    "J-WD 5C-5D": "#d82c00",
    "O-NH ChaPark": "#6d1800",
    RADCH: "#ca2f00",
    ENDOM: "#b52c00",
    "J-WD CAOAH": "#d43700",
    "J-WD Maty AU": "#f54300",
    "C-WD Chemo": "#bd3600",
    "C-DC DTU Haem": "#6d2100",
    "H-WD Oak": "#b13800",
    SEUAS: "#b33a00",
    "J-DC Immunology": "#842d00",
    "J-WD Robins": "#863000",
    MBCA: "#d95000",
    "O-DC Manor": "#dd5500",
    JAU: "#b34700",
    HAEMW: "#bd4e00",
    "C-DC Infect Dis": "#7f3600",
    ONCWD: "#cf5b00",
    "NOC-Ward F": "#914100",
    RDUWG: "#bd5800",
    M: "#af5400",
    "J-WD Child DC": "#d66900",
    CNMB: "#dd7000",
    "J-WD Gynae": "#974f00",
    "C-WD UrolTriage": "#b05e00",
    "J-WD Bell-Dray": "#6c3b00",
    "C-OP CHC": "#b76700",
    "J-WD Child CDU": "#e58400",
    "C-DC Renal": "#f18e00",
    VDU: "#995c00",
    "O-NH MillHouse": "#c87b00",
    MAUHG: "#ab6c00",
    MANOR: "#de8f00",
    NCARD: "#ac7100",
    "NOC-CDMS": "#ca8800",
    "O-NH WyndhmHall": "#835a00",
    "5ASRG": "#bb8200",
    "5AMED": "#c58c00",
    "J-WD NeuroPurpl": "#9f7400",
    "J-WD SSW": "#7e5e00",
    "J-WD 7E Osler": "#ae8300",
    "J-WD 5D AdultCF": "#937100",
    WYTHM: "#826500",
    "J-WD SEU E": "#bf9800",
    STR5B: "#846b00",
    "H-CW F Resp": "#c09e00",
    "J-WD Adult ICU": "#f0c900",
    "J-WD CMU-C": "#8c7700",
    "WL7 C": "#eaca00",
    WARIN: "#bca600",
    "H-DC Gynae": "#817300",
    "J-WD GPRU": "#dac500",
    "J-WD 7A": "#a39600",
    "J-WD Lionel Cos": "#d7c900",
    TOWL2: "#d3c800",
    OAB: "#787400",
    "J-DC Gastro": "#e8e200",
    "NOC-Ward E": "#c7c500",
    "O-NH ChilCourt": "#7a7a00",
    DIALY: "#979a00",
    BLEN1: "#a5aa00",
    "O-DC MKGH RDCU": "#6e7300",
    MCARD: "#b9c500",
    GER7F: "#656d00",
    "J-WD 6F": "#798500",
    "C-WD BagotDrake": "#bcd100",
    "C-WD JAC": "#707f00",
    "J-WD 7B": "#abc300",
    "J-WD Card": "#a5c000",
    "C-WD Sobell": "#718600",
    "C-WD Renal": "#c6ee00",
    CTCC1: "#819e00",
    "J-WD Vasc Lab": "#c7f700",
    "O-NH MonChoisey": "#586f00",
    "J-WD Adams": "#587100",
    "J-WD 6C SSW": "#b8f100",
    "J-WD 7C": "#aae300",
    NNW: "#b1f100",
    "H-DC Ophth": "#527100",
    "C-WD Urology": "#4e6f00",
    "H-DC Pathology": "#83bc00",
    "C-DC GI Phys": "#659400",
    "C-WD OncologySS": "#7fbe00",
    "C-WD EPCTU": "#6faa00",
    "J-DC Lichfield": "#80c700",
    "J-DC CAS": "#98f300",
    "NOC-Home L MUSC": "#93ef00",
    CARDO: "#3e6800",
    RESP: "#599800",
    VCSLU: "#91fd00",
    JDEL: "#4e8d00",
    "J-DC Litchfield": "#74d600",
    "O-NH IsisHouse": "#539e00",
    "C-DC MO RDU": "#73e000",
    PTDA: "#73e500",
    SURGA: "#7cfd00",
    ADAM2: "#357100",
    "J-WD DDU": "#3a7f00",
    "WL7 D": "#326f00",
    "WL2 A": "#63e400",
    "J-WD 4AAU": "#49ae00",
    "J-WD Trauma 3A": "#3b9100",
    CTWL2: "#54d600",
    MAUL1: "#5aec00",
    "J-WD Adam Bedfd": "#43b800",
    "NOC-Ward A": "#41ba00",
    "J-ED": "#3cb100",
    ONCLS: "#46da00",
    WL5CD: "#34a700",
    MAT6B: "#237700",
    "C-DC Derm": "#3acd00",
    GER7E: "#3bdb00",
    "O-DC TherapyGym": "#39de00",
    ITU: "#1a6b00",
    DSUMP: "#30d500",
    "C-WD OCJAW": "#29bf00",
    "O-NH Southerndn": "#177200",
    G: "#1b9200",
    "C-WD Wytham": "#2bf800",
    RENAL: "#27f600",
    "J-WD Child CCU": "#1fda00",
    ROBWD: "#1bce00",
    "J-WD Neuro Red": "#1cf200",
    "O-NH Churchflds": "#17db00",
    SOBEL: "#0b7e00",
    "J-WD CMU-B": "#086800",
    "O-NH Headington": "#0ff100",
    "Manor Hospital": "#056900",
    "C-DC Urology": "#07d100",
    DCTU: "#027a00",
    VLAB: "#01a800",
    "C-DC Urol MOP": "#006c00",
    "J-DC Card Nucr": "#00f604",
    EAU: "#00ee07",
    RDUSW: "#00ca09",
    PHDU: "#009809",
    NIPS: "#00f011",
    MATY: "#00740a",
    "C-WD OncHTriage": "#00d415",
    "C-DC DTU Chemo": "#008a0f",
    "H-WD Med Escaln": "#00ee1e",
    ENDOB: "#00db1f",
    "C-DC Wytham": "#00b51c",
    "J-DC 5E DCU": "#007313",
    OLGI: "#00a01d",
    "J-DC Diag Suite": "#00ab21",
    J: "#00cc2b",
    CCU: "#00c22b",
    "H-WD Childrens": "#009022",
    TRANS: "#00cc33",
    BRSPH: "#007920",
    "J-WD 5B Trauma": "#00d43b",
    "O-NH Yarnton": "#00e342",
    "O-NH Fewcott": "#00fb4d",
    "J-WD 7F Trauma": "#008b2c",
    CICU: "#00a537",
    "J-WD Maty L7": "#00ec52",
    "O-DC SMH RDCU": "#00832f",
    "O-NH Oakenholt": "#00a73e",
    "J-DC Lionel Cos": "#008032",
    RDUMK: "#007931",
    WWITU: "#00b94d",
    DCCA: "#00cd58",
    "J-WD NeuroGreen": "#00a047",
    "J-DC TDA": "#007f3a",
    "J-DC OMFS": "#009a48",
    "J-WD SSIP": "#007f3d",
    "NOC-Ward D": "#00ee76",
    BLEN2: "#006634",
    BROD: "#00cd6c",
    "NOC-Ward OSSU": "#00a257",
    SSIP: "#00b061",
    KAMW: "#00f98d",
    "O-WD Manor": "#00e686",
    "H-DC Brodey": "#007344",
    "J-WD 5F": "#00e289",
    "J-WD Neuro": "#00c379",
    "O-WD Foscote": "#00c77f",
    "O-NH Triangle": "#007149",
    TDACH: "#00ed9d",
    "J-WD 5A": "#00e198",
    MAT7B: "#00b67e",
    "H-WD F": "#008e64",
    "J-WD SEU D": "#00b07e",
    "C-WD Haem": "#008864",
    "J-WD Toms": "#006e52",
    "NOC-Ward B": "#007b5d",
    "H-DC Endoscopy": "#00d1a2",
    "J-DC Card CIA": "#00e1b1",
    THDIR: "#00d6ab",
    "J-WD Ward 6C": "#007761",
    "J-WD 5B Stroke": "#00caa7",
    "J-WD 7D": "#00f2cc",
    OCDEM: "#00a890",
    "J-DC AdultCF": "#00d5ba",
    SEUF: "#00cab3",
    "C-WD TDA": "#00f7de",
    "J-WD Maty OA": "#00a394",
    FEU7: "#00b3a6",
    "WL6 F": "#00b4a8",
    GYNAE: "#009b93",
    "NOC-HDU": "#006c68",
    "J-WD SEU Triage": "#00cbc7",
    "C-WD DischargeL": "#00f3f1",
    "C-WD CICU": "#00e1e3",
    "O-DC GWH RDCU": "#00ced2",
    HCW: "#00666a",
    "NOC-Admission Waiting Area": "#00a2aa",
    "O-DC Foscote": "#00727a",
    HAEMD: "#007680",
    MAT5B: "#00e5fb",
    F: "#007a88",
    MAT7A: "#00d7f3",
    "H-WD Maty": "#008194",
    "C-DC PD Renal": "#00a0bb",
    NISDC: "#007e96",
    "J-DC Gynae DSU": "#00c2ea",
    CTCCU: "#005569",
    "C-WD Transplant": "#006f8b",
    "C-WD Geoffrey H": "#00a1cc",
    MEDSS: "#00a3d3",
    "J-DC Cath Lab A": "#007ba1",
    "J-WD Trauma 2A": "#00526e",
    GEOFH: "#0086b7",
    "J-WD 5D": "#005f84",
    FELST: "#00618a",
    "WL5 E": "#005f8a",
    "C-RDA Main RDU": "#006ea3",
    "WL7 F": "#00a8fd",
    NIMDC: "#00649b",
    CARTH: "#005789",
    "H-DC DCU": "#009dfc",
    O: "#004470",
    MAT5A: "#0082da",
    XRESP: "#005c9f",
    HENDD: "#00457a",
    HGDSU: "#0076d6",
    "H-WD Rowan AU": "#005fb0",
    NNIU: "#00519b",
    MARIE: "#004a92",
    "J-DC Trauma DCU": "#007af4",
    "J-WD CritCareL3": "#003873",
    JDIAG: "#004a9e",
    "J-WD Trauma": "#00336f",
    "null ward name": "#004ba9",
    RENOF: "#0050bc",
    "H-WD Delivery": "#003e96",
    "J-WD 6B Stroke": "#0045ab",
    "J-WD Kamrans": "#005ef2",
    "J-WD CritCareL2": "#003ca1",
    L: "#002972",
    "NOC-MOP": "#003aa9",
    "J-WD John Warin": "#003bb2",
    "J-WD 6A Annexe": "#0044d4",
    "C-DC DSU": "#003abd",
    RDUSM: "#0040dc",
    "J-DC NIU": "#0036c3",
    "J-WD 7F": "#001c69",
    "J-DC DSU": "#001e78",
    "O-WD AHatHome": "#001c77",
    "O-NH Albany": "#0025a7",
    GDSU: "#0031ed",
    "J-WD EAU": "#002ad5",
    "O-NH Freeland": "#002df8",
    SEUES: "#00126e",
    OUGI: "#001799",
    LIDC: "#0022f5",
    ULTRA: "#000f7b",
    "O-NH Tall Trees": "#001cf9",
    "J-WD Transfer L": "#000e93",
    "H-DC Rowan Day": "#0010c0",
    PICU: "#000fcf",
    "O-NH Heathfield": "#000669",
    "C-DC Xray SDC": "#00046b",
    "J-WD SEU F": "#0005a1",
    "H-WD E": "#0003b3",
    "J-WD Paed HDU": "#0000aa",
    TDALG: "#01007d",
    SEUDS: "#0500ef",
    "O-NH BanHeights": "#0800dc",
    GER7D: "#0b00ea",
    "C-WD OncHaemAmb": "#090090",
    "J-WD 7E": "#1200eb",
    BEDF2: "#0f00a9",
    "J-DC Endoscopy": "#0d007d",
    "J-WD WWRecovery": "#1800cc",
    "J-WD Neuro ITU": "#1c00d9",
    "J-WD AdamTrauma": "#1800a7",
    "H-ED": "#2200d4",
    "J-DC OCMR": "#2600dc",
    CNMM: "#1c0096",
    ERCP: "#2d00e0",
    "J-WD CMU-A": "#1b0081",
    "J-WD CT Surgery": "#3700f0",
    "J-WD Newborn IC": "#2b00b4",
    MILAB: "#1b0069",
    "O-WD HDH": "#3300bf",
    DERMD: "#4800fe",
    "H-WD Rowan HL": "#280088",
    "O-NH St Lukes": "#2d0093",
    "O-NH Longlands": "#310099",
    "J-DC Radiology": "#3900aa",
    CARIN: "#5900fd",
    "WL6 A": "#4d00d4",
    "J-DC 5D AdultCF": "#5100d7",
    "J-WD Bedford": "#5500d9",
    "WL7 B": "#40009e",
    "J-WD Paed ICU": "#3f0096",
    DTUC: "#6e00fd",
    "C-WD Sobell Hse": "#5500be",
    CASDU: "#47009b",
    "NOC-PRO Ward": "#6700da",
    "H-WD ETU": "#7300eb",
    "J-WD 6A": "#6200c3",
    PNSS: "#7300df",
    "J-WD 5C": "#6800c5",
    "J-DC Vasc DU": "#8500f5",
    "C-WD John Warin": "#6300b2",
    "C-WD Oncol CTU": "#9000fc",
    "WL5 F": "#7a00d0",
    "J-WD Neuro HDU": "#7900ca",
    "J-WD Ward 6B": "#8100d3",
    "J-WD Ward 5E-5F": "#540087",
    "NOC-Discharge Waiting Area": "#66009f",
    DTUH: "#7300b1",
    "H-WD Crit Care": "#9300dc",
    ENDMH: "#8c00cd",
    "H-WD Trauma": "#ab00f6",
    "C-DC Sobell": "#b300fd",
    "O-NH The Close": "#6f0099",
    "J-WD Child TDA": "#4e006a",
    "J-Mortuary": "#7f00aa",
    "NOC-WD TDA": "#be00f8",
    "J-WD CTVCC": "#9100ba",
    "J-DC CAS Rec": "#a400cf",
    DAYCW: "#9300b7",
    "J-WD CMU-D": "#8800a6",
    ENDOS: "#c000e6",
    "J-DC AVIC Cath": "#c900ee",
    "J-WD Maty L5": "#6c007d",
    "C-WD Lower GI": "#aa00c2",
    "O-WD KH Ward": "#ac00c2",
    "J-WD TDA": "#7c0089",
    "NOC-Manor Hospital": "#d200e5",
    "H-WD Rowan Tran": "#9700a3",
    "J-WD MatL7Spire": "#87008f",
    NIPM: "#800086",
    "NOC-DSU": "#eb00f3",
    "C-WD Upper GI": "#8a008d",
    "J-WD Melanies": "#aa00ab",
    WRD15: "#ad00ab",
    "NOC-Rheumatology Day Unit": "#a400a0",
    "J-WD 6B": "#93008e",
    WLTH: "#97008f",
    "H-WD EAU": "#ad00a1",
    "J-DC Asthma": "#8c0080",
    "WL7 A": "#a40095",
    "J-WD Spires": "#d600bf",
    DISLG: "#66005a",
    "D S U": "#c400aa",
    "H-DC RDCU": "#8a0076",
    "H-WD Juniper": "#c600a6",
    "O-NH RampingCat": "#c900a6",
    "H-WD HDC Diag": "#f900ca",
    HGICU: "#74005d",
    RADDU: "#fe00c7",
    "NOC-Phase 2 Recovery": "#f600bd",
    "J-WD Recovery": "#c70096",
    INFDC: "#bb008a",
    OA: "#6d004f",
    MBCB: "#95006a",
    "O-NH HenCorn": "#ed00a6",
    "O-DC WGH RDCU": "#be0083",
    "C-DC Resp DCU": "#ca0088",
    DRAYW: "#e30096",
    "J-WD Maty L6": "#93005e",
    MELW: "#ab006c",
    "J-WD Delivery": "#760049",
    CHEMO: "#770048",
    "H-WD Recovery": "#ce0079",
    TOMW: "#b70069",
    "5FDCU": "#be006a",
    "J-WD AAU Home": "#f20085",
    E: "#aa005b",
    "J-WD PAU": "#6e0039",
    "C-WD Blen TDA": "#f8007e",
    JSCBU: "#6c0035",
    BELLW: "#f70076",
    "J-DC Cath Lab E": "#ca005e",
    "WL3 A": "#e00065",
    HB: "#b2004e",
    FOSCO: "#e50061",
    "C-DC Pain Mgt": "#800034",
    "C-WD Oncology": "#830034",
    JRCDU: "#690028",
    ESCJR: "#bb0045",
    "J-WD L4 AAU": "#85002f",
    "O-NH Winterbrk": "#d60049",
    SURGB: "#b1003a",
    WL6AX: "#710023",
    "C-DC Blenheim": "#7b0025",
    "NOC-OCE": "#e70042",
    JAC: "#e2003e",
    URDUM: "#67001b",
    PAU: "#b3002c",
    "NOC-Ward C": "#c5002e",
    WLCR: "#9f0023",
    "O-NH BeechHaven": "#ab0023",
    "J-WD Gyn Triage": "#ce0027",
    "J-WD 5B AAU": "#7a0015",
    "NOC-NRS": "#680011",
    "J-WD 5B": "#e20022",
    "H-WD Trauma F": "#800011",
    HEAU: "#a60014",
    "J-WD NeuroBlue": "#ac0012",
    "H-WD Laburnum": "#90000d",
    "WL5 C": "#9a000c",
    "NOC-Home L OCE": "#d0000e",
    "C-WD Blenheim": "#c3000a",
    CARD0: "#f3000a",
    ONCSS: "#e30006",
    MAT6A: "#830001",
  };

  return colours[ward];
}

function hospColourMap(hosp) {
  const colours = {
    Churchill: "#990000",
    OUH: "#d88100",
    Horton: "#7f9f00",
    "John Radcliffe": "#30f000",
    "Community Hospital": "#00933a",
    Manor: "#00c0c0",
    Satellite: "#005ce7",
    RTH89: "#2600bf",
    NOC: "#c700f9",
    nan: "#880051",
  };
  return colours[hosp];
}

function specialtyColourMap(specialty) {
  const colours = {
    "Acute Medicine": "#0000FF",
  };
  return colours[specialty];
}

//python script used to generate the colours above:
/**import colorsys
import random
import random

def generate_distinct_colors(num_colors):
    import colorsys
    
    colors = []
    for i in range(num_colors):
        hue = i / num_colors
        value = random.uniform(0.4, 1.0)  # Adjust the brightness here
        rgb = colorsys.hsv_to_rgb(hue, 1.0, value)
        hex_color = "#{:02x}{:02x}{:02x}".format(int(rgb[0] * 255), int(rgb[1] * 255), int(rgb[2] * 255))
        colors.append(hex_color)
    
    return colors

def run(wards):
    wards = set(wards)
    distinct_colors = generate_distinct_colors(len(wards))
    color_dict = dict(zip(wards, distinct_colors))
    print(color_dict)

wards = set(wards)
distinct_colors = generate_distinct_colors(len(wards))

color_dict = dict(zip(wards, distinct_colors))

print(color_dict) */
